/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Basegame_Checkbasegame3Inputs */

const id_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat game dasar`)
};

const ms_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat permainan asas`)
};

const da_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se basespillet`)
};

const de_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Basisspiel ansehen`)
};

const en_us2_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the base game`)
};

const es_es2_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver el juego base`)
};

const es_mx2_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver el juego base`)
};

const fil_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingnan ang base game`)
};

const fr_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir le jeu de base`)
};

const it_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controlla il gioco base`)
};

const hu_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alapjáték megtekintése`)
};

const nl_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk het basisspel`)
};

const no_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjekk grunnspillet`)
};

const pl_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprawdź grę podstawową`)
};

const pt_br2_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the base game`)
};

const pt_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver o jogo base`)
};

const ro_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vezi jocul de bază`)
};

const fi_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarkista peruspeli`)
};

const sv_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kolla grundspelet`)
};

const vi_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xem game cơ bản`)
};

const tr_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temel oyunu kontrol et`)
};

const cs_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkontrolovat základní hru`)
};

const bg_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверете основната игра`)
};

const ru_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проверить базовую игру`)
};

const uk_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Переглянути базову гру`)
};

const ar_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفح اللعبة الأساسية`)
};

const hi_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`बेस गेम देखें`)
};

const th_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูเกมหลัก`)
};

const ja_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベースゲームを確認`)
};

const zh_cn2_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the base game`)
};

const zh_hant1_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the base game`)
};

const ko_components_basegame_checkbasegame3 = /** @type {(inputs: Components_Basegame_Checkbasegame3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check the base game`)
};

/**
* | output |
* | --- |
* | "Check the base game" |
*
* @param {Components_Basegame_Checkbasegame3Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_basegame_checkbasegame3 = /** @type {((inputs?: Components_Basegame_Checkbasegame3Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Basegame_Checkbasegame3Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_basegame_checkbasegame3(inputs)
	if (locale === "ms") return ms_components_basegame_checkbasegame3(inputs)
	if (locale === "da") return da_components_basegame_checkbasegame3(inputs)
	if (locale === "de") return de_components_basegame_checkbasegame3(inputs)
	if (locale === "en-US") return en_us2_components_basegame_checkbasegame3(inputs)
	if (locale === "es-ES") return es_es2_components_basegame_checkbasegame3(inputs)
	if (locale === "es-MX") return es_mx2_components_basegame_checkbasegame3(inputs)
	if (locale === "fil") return fil_components_basegame_checkbasegame3(inputs)
	if (locale === "fr") return fr_components_basegame_checkbasegame3(inputs)
	if (locale === "it") return it_components_basegame_checkbasegame3(inputs)
	if (locale === "hu") return hu_components_basegame_checkbasegame3(inputs)
	if (locale === "nl") return nl_components_basegame_checkbasegame3(inputs)
	if (locale === "no") return no_components_basegame_checkbasegame3(inputs)
	if (locale === "pl") return pl_components_basegame_checkbasegame3(inputs)
	if (locale === "pt-BR") return pt_br2_components_basegame_checkbasegame3(inputs)
	if (locale === "pt") return pt_components_basegame_checkbasegame3(inputs)
	if (locale === "ro") return ro_components_basegame_checkbasegame3(inputs)
	if (locale === "fi") return fi_components_basegame_checkbasegame3(inputs)
	if (locale === "sv") return sv_components_basegame_checkbasegame3(inputs)
	if (locale === "vi") return vi_components_basegame_checkbasegame3(inputs)
	if (locale === "tr") return tr_components_basegame_checkbasegame3(inputs)
	if (locale === "cs") return cs_components_basegame_checkbasegame3(inputs)
	if (locale === "bg") return bg_components_basegame_checkbasegame3(inputs)
	if (locale === "ru") return ru_components_basegame_checkbasegame3(inputs)
	if (locale === "uk") return uk_components_basegame_checkbasegame3(inputs)
	if (locale === "ar") return ar_components_basegame_checkbasegame3(inputs)
	if (locale === "hi") return hi_components_basegame_checkbasegame3(inputs)
	if (locale === "th") return th_components_basegame_checkbasegame3(inputs)
	if (locale === "ja") return ja_components_basegame_checkbasegame3(inputs)
	if (locale === "zh-CN") return zh_cn2_components_basegame_checkbasegame3(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_basegame_checkbasegame3(inputs)
	return ko_components_basegame_checkbasegame3(inputs)
});
export { components_basegame_checkbasegame3 as "components.baseGame.checkBaseGame" }